module.exports = __webpack_public_path__ + "assets/img/activity_newuser_bg2.7dbd285e.png";